module.exports = __webpack_public_path__ + "img/4.fdc58ebb.png";